import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Radio,
  Label,
  Dropdown
} from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react-17';
import _ from 'lodash';
import { userActions } from '../../actions/user.actions';
import { userConstants } from '../../constants/user.constants';
import PropTypes from 'prop-types';
import { delegationActions } from '../../actions/delegation.actions';
import moment from 'moment';

class DelegationFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delegation: {    
        title: '',
        description: '',
        startDate: null,
        endDate: null,
        userId: null,
        delegatedUserId: null,
      },
      selectedUser: null,
      selectedDelegatedUser: null,
      errors: {},
      submitted: false
    };    
  }

  componentDidMount() {
    const { match, dispatch } = this.props;    
    if (match.params.id) {
        dispatch(delegationActions.get(match.params.id))
            .then(() => {                
                const delegation = _.mapKeys(this.props.delegation, function (v, k) { return k.toLowerCase(); });                
                this.setState({ delegation })
            });
    } 
    
    this.fetchManagers();
    
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchManagers();
    }, 500);
  }

  static get propTypes() { 
    return {       
        me: PropTypes.any,        
        delegation: PropTypes.any,
        loading: PropTypes.bool,
        match: PropTypes.any,
    }; 
  }

  fetchManagers() {
    const { dispatch } = this.props;
    const { search } = this.state;
    dispatch(userActions.managers({ search, orderBy: "Name", pageSize: 50000 }));
  }

  handleChange(field, data) {            
    const { delegation } = this.state;    
    const { managers } = this.props;    
    delegation[field] = data;    

    if (field === 'userId' && managers && managers.Results) {
      for (let manager of managers.Results) {
        if (manager.Id === data) {
          this.setState({ selectedUser: manager })
        }
      }      
    }

    if (field === 'delegatedUserId' && managers && managers.Results) {
      for (let manager of managers.Results) {
        if (manager.Id === data) {
          this.setState({ selectedDelegatedUser: manager })
        }
      }      
    }

    this.setState({ delegation });    
  }

  validate() {
    const { delegation } = this.state;
    const { me } = this.props;
    
    let errors = {};
    let valid = true;

    if (!delegation.title || delegation.title.length == 0) {
      errors.title = "Preencha o título";
      valid = false;
    }

    if (!delegation.description || delegation.description.length == 0) {
      errors.description = "Preencha a descrição";
      valid = false;
    }

    if (!delegation.startDate) {
      errors.startDate = "Preencha a data de início";
      valid = false;
    }

    if (!delegation.endDate) {
      errors.endDate = "Preencha a data de fim";
      valid = false;
    }

    if (me && me.Role === userConstants.ROLE_ADMIN && !delegation.userId) {
      errors.userId = "Selecione o usuário";
      valid = false;
    }

    if (!delegation.delegatedUserId) {
      errors.delegatedUserId = "Selecione o usuário delegado";
      valid = false;
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { delegation } = this.state;    

    delegation.startDate = moment(delegation.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');      
    delegation.endDate = moment(delegation.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');      
    if (delegation.id) {
        dispatch(delegationActions.update(delegation.id, delegation));
    } else {
        dispatch(delegationActions.create(delegation));
    }
  }

  handleUserSearchChange(search) {    
    this.setState({ search });
    this.handleSearchDebounced();
  }

  simpleSearch(options, query) {    
    query = query.toLowerCase();        
    return options.filter(opt => {        
      return (opt.text && opt.text.toLowerCase().indexOf(query) >= 0) || (opt.description && opt.description.toLowerCase().indexOf(query) >= 0);
    });
  }

  render() {    
    const { delegation, errors, selectedUser, selectedDelegatedUser } = this.state;        
    const { managers, me, usersLoading } = this.props;    

    // Check Permission
    if (me && me.permissions && !me.permissions.includes("delegation.create")) {
      window.location.href = "/";
      return;
    };
    
    let managerOptions = [];             
    if (managers && managers.Results) {            
      if (selectedUser) {
        managers.Results.push(selectedUser);
      }

      if (selectedDelegatedUser) {
        managers.Results.push(selectedDelegatedUser);
      }
      
      managerOptions = managers.Results.map(item => {
        return { key: item.Id, value: item.Id, text: item.Name, description: item.Email, username: item.Username }
      });

      const uniqueManagers = [];
      const uniqueManagerIds = [];
      for (let i = 0; i < managerOptions.length; i++) {
        if (!uniqueManagerIds.includes(managerOptions[i].key)) {
          uniqueManagerIds.push(managerOptions[i].key);
          uniqueManagers.push(managerOptions[i]);
        }
      }

      managerOptions = uniqueManagers;

      if (delegation.user) {
        managerOptions.push({key: delegation.user.Id, value: delegation.user.Id, text: delegation.user.Name, description: delegation.user.Email, username: delegation.user.Username});
      }

      if (delegation.delegateUser) {
        managerOptions.push({key: delegation.delegateUser.Id, value: delegation.delegateUser.Id, text: delegation.delegateUser.Name, description: delegation.delegateUser.Email, username: delegation.delegateUser.Username});
      }
    }
    
    return (  
      <Fragment>
      <h1>Delegação de Aprovação</h1>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>        
        <Form.Input required error={errors.title} label='Título' value={delegation.title} name='title' type='text' onChange={(e, data) => this.handleChange("title", data.value)} placeholder='Motivo da delegação' />
        { errors.title && <Label color='red'>{errors.title}</Label>}

        <Form.TextArea required error={errors.description} label='Descrição' value={delegation.description} name='description' onChange={(e, data) => this.handleChange("description", data.value)} type='textarea' placeholder='Descreva o motivo da delegação' />
        { errors.description && <Label color='red'>{errors.description}</Label>}

        <Form.Field required>
            <label>Data Início</label>
            <DateInput
              localization="pt-br"
              name="startDate"
              closable
              clearable
              placeholder="Data"
              value={delegation.startDate}
              minDate={new Date()}
              dateFormat="DD/MM/YYYY"
              iconPosition="left"
              onChange={(e, data) => this.handleChange("startDate", data.value)}
            />
            { errors.startDate && <Label basic pointing color='red'>{errors.startDate}</Label>}
          </Form.Field>        

          <Form.Field required>
            <label>Data Fim</label>
            <DateInput
              localization="pt-br"
              name="endDate"
              closable
              clearable
              placeholder="Data"
              value={delegation.endDate}
              minDate={new Date()}
              dateFormat="DD/MM/YYYY"
              iconPosition="left"
              onChange={(e, data) => this.handleChange("endDate", data.value)}
            />
            { errors.startDate && <Label basic pointing color='red'>{errors.startDate}</Label>}
          </Form.Field>        

          {me && me.Role === userConstants.ROLE_ADMIN && <Form.Field>
            <label>Usuário Aprovador Original</label>
            <Dropdown
            placeholder='Busque por nome, e-mail ou username'
            fluid    
            clearable        
            selection            
            loading={usersLoading}
            onChange={(e, data) => this.handleChange("userId", data.value)}
            // onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}                        
            search={(opt, qry) => this.simpleSearch(opt, qry)}
            value={delegation.userId} 
            options={managerOptions}
          />                        
            { errors.userId && <Label basic pointing color='red'>{errors.userId}</Label>}
        </Form.Field>}

        <Form.Field>
            <label>Delegar Aprovações para o Usuário</label>
            <Dropdown
            placeholder='Busque por nome, e-mail ou username'
            fluid    
            clearable        
            selection            
            loading={usersLoading}
            onChange={(e, data) => this.handleChange("delegatedUserId", data.value)}
            onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}                        
            search={(opt, qry) => this.simpleSearch(opt, qry)}
            value={delegation.delegatedUserId} 
            options={managerOptions}
          />                        
            { errors.delegatedUserId && <Label basic pointing color='red'>{errors.delegatedUserId}</Label>}
        </Form.Field>
              
        <Button primary type='submit'>{delegation.id ? 'Alterar' : 'Criar'} Delegação</Button>
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, delegations } = state;  
  let props = {
    me: users.me || null,        
    usersLoading: users.loading,    
    managers: users.managers || null,
    loading: delegations?.loading,    
  };

  if (delegations && delegations.item) {
      props.delegation = delegations.item;      
  }
  
  return props;
}

const connectedDelegationFormScreen = connect(mapStateToProps)(DelegationFormScreen);
export { connectedDelegationFormScreen as DelegationFormScreen };
